<template>
	<v-container class="pa-0">
		<div v-if="formLevel === 1">
			<div v-if="remarks" class="text-xs-center">
				Reason For Rejection: {{ remarks }}
			</div>
			<google-map @GET_LOCATION_INFO="getLocationInfo" />
			<div v-if="showAddress">
				<v-flex class="mt-4">
					<v-text-field
						label="Address"
						v-model="payload.address"
						outline
						@change="val => handleFieldChange('address', val)"
					></v-text-field>
				</v-flex>
				<v-flex xs12 sm6>
					<v-text-field
						label="Pin Code"
						v-model="payload.pincode"
						outline
						type="number"
						@change="val => handleFieldChange('pincode', val)"
					></v-text-field>
				</v-flex>
				<div class="justify-space-between">
					<v-select
						:items="states"
						label="Select State"
						v-model="payload.state"
						class="mr-2"
						@change="val => handleFieldChange('state', val)"
					></v-select>
					<v-select
						:items="cities"
						label="Select City"
						v-model="payload.city"
						class="ml-2"
						@change="val => handleFieldChange('city', val)"
					></v-select>
				</div>
			</div>
		</div>
		<div v-else>
			<h2 class="text-xs-center">
				Upload Address Proof of Shop/Bussiness
			</h2>
			<div class="uploadBox">
				<label class="pa-2" for="files">Upload GST Certificate: </label>
				<v-layout class="pa-3" align-center>
					<v-flex xs6 sm4 md4>
						<v-btn :disabled="disableUpload === gst"
							><input
								ref="inputUpload1"
								type="file"
								@change="val => onFileChange(gst, val)"
								class="input"
						/></v-btn> </v-flex
					><v-flex xs2 sm1 md1 class="cancelIcon">
						<v-icon
							class="cancel-icon"
							@click="clearInput('inputUpload1', gst)"
						>
							{{ "cancel" }}
						</v-icon>
					</v-flex>
				</v-layout>
			</div>
			<div class="uploadBox">
				<label class="pa-2" for="files">Current Address Proof: </label>
				<v-layout class="pa-3" align-center>
					<v-flex xs6 sm4 md4>
						<v-btn :disabled="disableUpload === other"
							><input
								ref="inputUpload2"
								type="file"
								@change="val => onFileChange(other, val)"
								class="input"
						/></v-btn> </v-flex
					><v-flex xs2 sm1 md1 class="cancelIcon">
						<v-icon
							class="cancel-icon"
							@click="clearInput('inputUpload2', other)"
						>
							{{ "cancel" }}
						</v-icon>
					</v-flex>
				</v-layout>
			</div>
			<v-flex class="mt-4">
				<v-text-field
					label="Doc No"
					v-model="payload.docNo"
					outline
					@change="val => handleFieldChange('docNo', val)"
				></v-text-field>
			</v-flex>
			<div class="text-xs-center">
				<img
					v-if="payload.shopImage"
					:src="payload.shopImage"
					alt
					class="imageSize"
				/>
			</div>
			<div class="uploadBox">
				<label class="pa-2" for="files"
					>Upload a Front View Photo of Shop/Business:</label
				>
				<v-layout class="pa-3" align-center>
					<v-flex xs6 sm4 md4
						><input
							ref="input"
							type="file"
							@change="val => onFileChange(shopImage, val)"
							accept="image/*"
							capture="camera"
							style="display:none"
						/>
						<v-btn @click="$refs.input.click()">Take Photo</v-btn>
					</v-flex>
				</v-layout>
			</div>
		</div>
		<div class="justify-space-between">
			<v-btn @click="goBack">Back</v-btn>
			<v-btn
				v-if="formLevel === 1"
				@click="formLevel = 2"
				:disabled="
					!payload.address ||
						!payload.pincode ||
						!payload.state ||
						!payload.city
				"
				:color="themeInputColor"
				class="white--text"
				>Next</v-btn
			>
			<v-btn
				v-else
				@click="handleSubmit"
				:disabled="
					!payload.docUrl ||
						!payload.docType ||
						!payload.shopImage ||
						!payload.docNo
				"
				:color="themeInputColor"
				class="white--text"
				>Submit</v-btn
			>
		</div>
		<v-dialog v-model="showFileTypeError" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Selected correct file</span>
				</v-card-title>
				<div class="text-xs-center" style="font-size:large;">
					Please select {{ uploadFileType }} file only
				</div>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="error" flat @click="showFileTypeError = false"
						>Close</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
		<div v-if="isLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</v-container>
</template>

<script>
import { mapState } from "vuex";
import {
	FETCH_REGIONS,
	UPLOAD_MEDIA_TO_SERVER,
	UPDATE_EXISTING_RETAILER,
	FETCH_JEET11_PARTNER_WALLET_DETAILS
} from "@/store/action-types";
import { REGION_TYPE } from "@/utils";
import GoogleMap from "../GoogleMap.vue";

let filePayload = null;

export default {
	name: "EditLocation",
	props: ["retailerData", "themeInputColor"],
	data() {
		return {
			payload: {
				latitude: "",
				longitude: "",
				address: "",
				shopImage: "",
				docNo: "",
				docType: "",
				docUrl: "",
				state: "",
				city: "",
				pincode: ""
			},
			showAddress: false,
			formLevel: 1,
			uploadKey: "addressProof",
			disableUpload: "",
			gst: "GST",
			other: "ADDRESS_PROOF",
			shopImage: "shopImage",
			isLoading: false,
			uploadFileType: "PDF or Image",
			showFileTypeError: false,
			remarks: null
		};
	},
	mounted() {
		this.payload.state = this.retailerData.state;
		this.payload.city = this.retailerData.city;
		this.remarks = this.jeet11PartnerDetails.remarks;
	},
	components: {
		"google-map": GoogleMap
	},
	methods: {
		getLocationInfo(locationInfo) {
			this.payload.latitude = locationInfo.lat;
			this.payload.longitude = locationInfo.lng;
			this.payload.state = locationInfo.state.toUpperCase();
			this.fetchCities();
			this.payload.city = this.cities.find(city => {
				const isCityMatching =
					locationInfo.city.toUpperCase() === city.toUpperCase();
				if (isCityMatching) this.payload.city = city;
				return isCityMatching;
			})
				? this.payload.city
				: "";
			this.payload.pincode = locationInfo.postalCode;
			this.showAddress = true;
		},
		goBack() {
			if (this.formLevel === 1) this.$emit("SET_EDIT_LOCATION");
			else this.formLevel = 1;
		},
		handleFieldChange(key, value) {
			this.payload[key] = value;
			if (key === "state") {
				this.fetchCities();
				this.payload.city = "";
			}
		},
		uploadFile(type) {
			this.isLoading = true;
			const isShopImage = type === this.shopImage;
			this.uploadKey = isShopImage ? "shopImageProof" : this.uploadKey;
			this.$store
				.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
					key: this.uploadKey,
					file: filePayload
				})
				.then(data => {
					if (!isShopImage) {
						this.payload.docUrl = data.fileUrl;
						this.payload.docType = type;
					} else {
						this.payload.shopImage = data.fileUrl;
					}
				})
				.finally(() => (this.isLoading = false));
		},
		onFileChange(type, e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			filePayload = files[0];
			if (type !== this.shopImage) {
				if (
					!filePayload.type.includes("pdf") &&
					!filePayload.type.includes("image")
				) {
					this.showFileTypeError = true;
					this.uploadFileType = "PDF or Image";
					this.clearInput("inputUpload1", this.gst);
					this.clearInput("inputUpload2", this.other);
					return;
				} else {
					this.showFileTypeError = false;
					this.disableUpload =
						type === this.gst ? this.other : this.gst;
				}
			} else if (!filePayload.type.includes("image")) {
				this.showFileTypeError = true;
				this.uploadFileType = "image";
				return;
			} else {
				this.showFileTypeError = false;
			}
			this.uploadFile(type);
		},
		clearInput(inputUpload, type) {
			this.$refs[inputUpload].value = "";
			if (this.disableUpload) {
				this.disableUpload =
					type === this.disableUpload ? this.disableUpload : "";
			}
		},
		handleSubmit() {
			this.isLoading = true;
			this.$store
				.dispatch(UPDATE_EXISTING_RETAILER.dispatch, this.payload)
				.then(() => {
					this.$emit("SET_EDIT_LOCATION");
					this.fetchJeet11WalletDetails();
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		fetchJeet11WalletDetails() {
			this.$store.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
				isSchemeRequired: true,
				isCardGame: 0
			});
		},
		fetchCities() {
			this.$store.dispatch(FETCH_REGIONS.dispatch, {
				regionType: REGION_TYPE.CITY,
				state: this.payload.state,
				dataKey: "cities"
			});
		}
	},
	computed: {
		...mapState({
			states: state => state.common.states,
			cities: state => state.common.cities,
			jeet11PartnerDetails: state => state.jeet11.jeet11PartnerDetails
		})
	}
};
</script>

<style scoped>
.uploadBox {
	background-color: #f5f5f5;
	padding: 0.5rem;
	margin-top: 1rem;
}
.cancelIcon {
	position: absolute;
	right: 10%;
}
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}
.imageSize {
	min-width: 300px;
	height: 300px;
}
</style>
